import { AiOutlineDollar, AiOutlineTransaction } from 'react-icons/ai';
import { BiHomeAlt2 } from 'react-icons/bi';
import { FaArrowsRotate } from 'react-icons/fa6';
import { FiSend } from 'react-icons/fi';
import { GoArrowDownRight, GoChecklist, GoRocket } from 'react-icons/go';
import { IoWarningOutline } from 'react-icons/io5';
import { MdAccountBalance, MdArrowOutward, MdOutlinePolicy, MdOutlineVisibility, MdVerifiedUser } from 'react-icons/md';
import { PiVault } from 'react-icons/pi';
import { RiGroupLine, RiUserSearchLine } from 'react-icons/ri';
import { TbReportMedical } from 'react-icons/tb';
import { VscArrowSwap, VscTools } from 'react-icons/vsc';
import { PermissionsV2 } from 'constants/permissions_v2';
import RfiEntityDetail from 'modules/kyc/components/RfiEntityDetail';
import CreatePolicy from 'modules/policies/CreatePolicy';
import BankingPostOnboarding from 'modules/postonboarding/BankingPostOnboarding';
import TransactionRiskAlerts from 'modules/transaction-risks/TransactionRiskAlerts';
import Accounts from 'pages/accounts';
import ApproveTransactionsV2 from 'pages/approve-transactions-v2';
import AuditLogs from 'pages/auditLogs';
import Beneficiaries from 'pages/beneficiaries';
import BeneficiaryDetailsPage from 'pages/beneficiary-details';
import Corridors from 'pages/corridors';
import CreateSettlement from 'pages/CreateSettlement';
import CreditTransactions from 'pages/credit-transactions';
import DebitTransactions from 'pages/debit-transaction';
import FeesBreakdownReports from 'pages/fees-breakdown-reports';
import Home from 'pages/home';
import InternalUsers from 'pages/internalusers';
import KybRfi from 'pages/kyb';
import KybDetails from 'pages/kyb-details';
import KycRfi from 'pages/kyc';
import MerchantInfo from 'pages/merchantinfo';
import Merchants from 'pages/merchants';
import MfaPage from 'pages/mfa/MfaPage';
import SetupMfa from 'pages/mfa/SetupMfa';
import OTCTrade from 'pages/otc';
import PartnerAccountTransfer from 'pages/partner-account-transfer';
import PartnerVisibility from 'pages/partner-visibility';
import PartnerCustomerBalances from 'pages/partner-visibility/customer-balances';
import Policies from 'pages/policies';
import PostOnboarding from 'pages/postonboarding';
import SettlementReports from 'pages/settlement-reports';
import SuperMerchantBeneficiariesPage from 'pages/super-merchant-beneficiaries';
import SuperMerchantConfig from 'pages/supermerchant-config';
import SuperMerchantKYB from 'pages/supermerchant-kyb';
import TechSupportRequest from 'pages/techsupport';
import TransactionRisks from 'pages/transaction-risks';
import TransactionsV2 from 'pages/transactions_v2';
import UnmappedCreditTransactions from 'pages/unmapped-credit-transactions';
import WhiteListResources from 'pages/whitelist-resources';

export var opsDashboardRoutes = [
  {
    path: '/home',
    name: 'Home',
    icon: <BiHomeAlt2 color='inherit' />,
    component: Home,
    layout: '/dashboard',
    base_permission: '',
  },
  {
    path: '/merchant/:merchantId',
    name: 'MerchantInfo',
    icon: <RiUserSearchLine color='inherit' />,
    component: MerchantInfo,
    layout: '/dashboard',
    base_permission: PermissionsV2.VIEW_MERCHANT_INFORMATION,
  },
  {
    path: '/post-onboarding/banking/entity/:entityId',
    name: 'Banking Post Onboarding',
    icon: <GoRocket color='inherit' />,
    component: BankingPostOnboarding,
    layout: '/dashboard',
    base_permission: PermissionsV2.MANAGE_POST_ONBOARDING_ACCOUNT_CONFIGS,
  },
  {
    path: '/kyc/rfi/entity/:entityId',
    name: 'KYC RFI Entity',
    icon: <GoRocket color='inherit' />,
    component: RfiEntityDetail,
    layout: '/dashboard',
    base_permission: PermissionsV2.MANAGE_KYC_COMPLIANCE_OPERATIONS,
  },
  {
    path: '/kyb/details/:kybId',
    name: 'KYB Details',
    icon: <MdVerifiedUser color='inherit' />,
    component: KybDetails,
    layout: '/dashboard',
    base_permission: PermissionsV2.VIEW_KYB_COMPLIANCE_OPERATIONS,
  },
  {
    path: '/transaction/:transactionId/risk-alerts',
    name: 'Transaction Risk Alerts',
    icon: <IoWarningOutline />,
    component: TransactionRiskAlerts,
    layout: '/dashboard',
    base_permission: PermissionsV2.VIEW_TRANSACTION_RISKS_COMPLIANCE_OPERATIONS,
  },
  {
    path: '/beneficiaries/super-merchant/:superMerchantId',
    name: 'Super Merchant Beneficiaries',
    icon: <RiGroupLine color='inherit' />,
    component: SuperMerchantBeneficiariesPage,
    layout: '/dashboard',
    base_permission: PermissionsV2.VIEW_WHITELIST_RESOURCES_OPERATIONS,
  },
  {
    path: '/beneficiaries/details/:beneficiaryId',
    name: 'Beneficiary Details',
    icon: <RiGroupLine color='inherit' />,
    component: BeneficiaryDetailsPage,
    layout: '/dashboard',
    base_permission: PermissionsV2.VIEW_WHITELIST_RESOURCES_OPERATIONS,
  },
  {
    path: '/merchants',
    name: 'Merchants',
    icon: <RiUserSearchLine color='inherit' />,
    component: Merchants,
    layout: '/dashboard',
    base_permission: PermissionsV2.VIEW_MERCHANTS,
  },
  // {
  //   path: '/kyb-submission/banking/entity/:entityId',
  //   name: 'Banking KYB Submission',
  //   icon: <FiUpload color='inherit' />,
  //   component: BankingOnboarding,
  //   layout: '/dashboard',
  //   base_permission: PermissionsV2.MANAGE_KYB,
  // },
  // {
  //   path: '/kyb-submission/treasury/entity/:entityId',
  //   name: 'Treasury KYB Submission',
  //   icon: <FiUpload color='inherit' />,
  //   component: TreasuryOnboarding,
  //   layout: '/dashboard',
  //   base_permission: PermissionsV2.MANAGE_KYB,
  // },
  {
    name: 'Account configs',
    icon: <PiVault color='inherit' />,
    layout: '/dashboard',
    children: [
      {
        path: '/account-management',
        name: 'Add Account',
        icon: <PiVault color='inherit' />,
        component: Accounts,
        layout: '/dashboard',
        base_permission: PermissionsV2.VIEW_ADD_ACCOUNT_ACCOUNT_CONFIGS,
      },
      {
        path: '/corridors',
        name: 'Corridors',
        icon: <VscArrowSwap color='inherit' />,
        component: Corridors,
        layout: '/dashboard',
        base_permission: PermissionsV2.VIEW_CORRIDORS_ACCOUNT_CONFIGS,
      },
      {
        path: '/post-onboarding',
        name: 'Post Onboard Entity',
        icon: <GoRocket color='inherit' />,
        component: PostOnboarding,
        layout: '/dashboard',
        base_permission: PermissionsV2.VIEW_POST_ONBOARDING_ACCOUNT_CONFIGS,
      },
    ],
  },
  {
    name: 'Operations',
    icon: <FaArrowsRotate color='inherit' />,
    layout: '/dashboard',
    children: [
      {
        path: '/debits',
        name: 'Ops (Debit transactions)',
        icon: <MdArrowOutward color='inherit' />,
        component: TransactionsV2,
        layout: '/dashboard',
        base_permission: PermissionsV2.VIEW_OPS_OPERATIONS,
      },
      {
        path: '/unmapped-credits  ',
        name: 'Unmapped Credits',
        icon: <GoArrowDownRight color='inherit' />,
        component: UnmappedCreditTransactions,
        layout: '/dashboard',
        base_permission: PermissionsV2.VIEW_UNMAPPED_CREDITS_OPERATIONS,
      },
      {
        path: '/whitelist-resources',
        name: 'Whitelist Resources',
        icon: <MdAccountBalance />,
        component: WhiteListResources,
        layout: '/dashboard',
        base_permission: PermissionsV2.VIEW_WHITELIST_RESOURCES_OPERATIONS,
      },
      {
        path: '/beneficiaries',
        name: 'Beneficiaries',
        icon: <RiGroupLine color='inherit' />,
        component: Beneficiaries,
        layout: '/dashboard',
        base_permission: PermissionsV2.VIEW_WHITELIST_RESOURCES_OPERATIONS,
      },
      {
        path: '/otc',
        name: 'Place an OTC trade',
        icon: <AiOutlineDollar color='inherit' />,
        component: OTCTrade,
        layout: '/dashboard',
        base_permission: PermissionsV2.CREATE_PLACEMENT_ORDERS_OPERATIONS,
      },
      {
        path: '/settlement-reports',
        name: 'Settlement Reports',
        icon: <AiOutlineDollar color='inherit' />,
        component: SettlementReports,
        layout: '/dashboard',
        base_permission: PermissionsV2.VIEW_SETTLEMENT_REPORTS_OPERATIONS,
      },
      {
        path: '/fees-breakdown-reports',
        name: 'Fees Breakdown Reports',
        icon: <AiOutlineDollar color='inherit' />,
        component: FeesBreakdownReports,
        layout: '/dashboard',
        base_permission: PermissionsV2.VIEW_SETTLEMENT_REPORTS_OPERATIONS,
      },
      {
        path: '/supermerchant-config',
        name: 'Supermerchant Config',
        icon: <AiOutlineDollar color='inherit' />,
        component: SuperMerchantConfig,
        layout: '/dashboard',
        base_permission: PermissionsV2.VIEW_SUPERMERCHANT_CONFIG_OPERATIONS,
      },
      {
        path: '/supermerchant-kyb',
        name: 'Supermerchant KYB',
        icon: <AiOutlineDollar color='inherit' />,
        component: SuperMerchantKYB,
        layout: '/dashboard',
        base_permission: PermissionsV2.CREATE_SUPERMERCHANT_KYB_CONFIG_OPERATIONS,
      },
    ],
  },
  {
    name: 'Compliance Ops',
    icon: <TbReportMedical color='inherit' />,
    layout: '/dashboard',
    children: [
      {
        path: '/kyc',
        name: 'KYC',
        icon: <MdVerifiedUser color='inherit' />,
        component: KycRfi,
        layout: '/dashboard',
        base_permission: PermissionsV2.VIEW_KYC_COMPLIANCE_OPERATIONS,
      },
      {
        path: '/kyb',
        name: 'KYB',
        icon: <MdVerifiedUser color='inherit' />,
        component: KybRfi,
        layout: '/dashboard',
        base_permission: PermissionsV2.VIEW_KYB_COMPLIANCE_OPERATIONS,
      },
      {
        path: '/credits',
        name: 'Credit Transactions',
        icon: <GoArrowDownRight color='inherit' />,
        component: CreditTransactions,
        layout: '/dashboard',
        base_permission: PermissionsV2.VIEW_CREDITS_IN_REVIEW_COMPLIANCE_OPERATIONS,
      },
      {
        path: '/debit-transactions',
        name: 'Debit Transactions',
        icon: <GoChecklist />,
        component: DebitTransactions,
        layout: '/dashboard',
        base_permission: PermissionsV2.VIEW_DEBIT_TRANSACTIONS_COMPLIANCE_OPERATIONS,
      },
      {
        path: '/risky-transactions',
        name: 'Transactions With Risks',
        icon: <IoWarningOutline />,
        component: TransactionRisks,
        layout: '/dashboard',
        base_permission: PermissionsV2.VIEW_TRANSACTION_RISKS_COMPLIANCE_OPERATIONS,
      },
    ],
  },
  {
    name: 'Fund Transfers',
    icon: <FiSend color='inherit' />,
    layout: '/dashboard',
    children: [
      {
        path: '/payments',
        name: 'Payments',
        icon: <FiSend color='inherit' />,
        component: ApproveTransactionsV2,
        layout: '/dashboard',
        base_permission: PermissionsV2.VIEW_PAYMENTS,
      },
      {
        path: '/partner-account-transfer',
        name: 'Partner Account Transfer',
        icon: <MdArrowOutward color='inherit' />,
        component: PartnerAccountTransfer,
        layout: '/dashboard',
        base_permission: PermissionsV2.VIEW_PAYMENTS,
      },
    ],
  },
  {
    path: '/create-settlement',
    name: 'Create Settlement',
    icon: <FiSend color='inherit' />,
    component: CreateSettlement,
    layout: '/dashboard',
    base_permission: PermissionsV2.CREATE_PAYMENTS,
  },
  {
    path: '/partner-visibility/:partnerCode',
    name: 'Partner Customer Balances',
    icon: <MdOutlineVisibility color='inherit' />,
    component: PartnerCustomerBalances,
    layout: '/dashboard',
    base_permission: PermissionsV2.VIEW_PARTNER_VISIBILITY,
  },
  {
    path: '/partner-visibility',
    name: 'Partner Visibility',
    icon: <MdOutlineVisibility color='inherit' />,
    component: PartnerVisibility,
    layout: '/dashboard',
    base_permission: PermissionsV2.VIEW_PARTNER_VISIBILITY,
  },
  {
    path: '/tech-support-request',
    name: 'Request Tech Support',
    icon: <VscTools color='inherit' />,
    component: TechSupportRequest,
    layout: '/dashboard',
    base_permission: PermissionsV2.VIEW_REQUEST_TECH_SUPPORT,
  },
  // {
  //   path: '/kyb-submission',
  //   name: 'Submit Customer KYB',
  //   icon: <FiUpload color='inherit' />,
  //   component: Onboarding,
  //   layout: '/dashboard',
  //   base_permission: PermissionsV2.MANAGE_KYB,
  // },
  {
    path: '/users',
    name: 'Users',
    icon: <RiGroupLine color='inherit' />,
    component: InternalUsers,
    layout: '/dashboard',
    base_permission: PermissionsV2.VIEW_USERS,
  },
  {
    path: '/policies/create',
    name: 'Create Policies',
    icon: <MdOutlinePolicy color='inherit' />,
    component: CreatePolicy,
    layout: '/dashboard',
    base_permission: PermissionsV2.CREATE_PAYMENT_POLICIES,
  },
  {
    path: '/policies',
    name: 'Policies',
    icon: <MdOutlinePolicy color='inherit' />,
    component: Policies,
    layout: '/dashboard',
    base_permission: PermissionsV2.VIEW_PAYMENT_POLICIES,
  },
  {
    path: '/mfa/setup',
    name: 'MFA Setup',
    icon: <MdVerifiedUser color='inherit' />,
    component: SetupMfa,
    layout: '/dashboard',
    base_permission: '',
  },
  {
    path: '/mfa',
    name: 'MFA Settings',
    icon: <MdVerifiedUser color='inherit' />,
    component: MfaPage,
    layout: '/dashboard',
    base_permission: '',
  },
];

export var lumosDashboardRoutes = [
  {
    path: '/merchants',
    name: 'Merchants',
    icon: <RiUserSearchLine color='inherit' />,
    component: Merchants,
    layout: '/dashboard',
    base_permission: PermissionsV2.VIEW_MERCHANTS,
  },
  {
    path: '/merchant/:merchantId',
    name: 'MerchantInfo',
    icon: <RiUserSearchLine color='inherit' />,
    component: MerchantInfo,
    layout: '/dashboard',
    base_permission: PermissionsV2.VIEW_MERCHANTS,
  },
  {
    path: '/audit-logs',
    name: 'Audit Logs',
    icon: <AiOutlineTransaction color='inherit' />,
    component: AuditLogs,
    layout: '/dashboard',
    base_permission: PermissionsV2.VIEW_MERCHANTS,
  },
];
